import React from 'react';
import {connect} from 'react-redux';
import {CollapsibleLinkpile} from '@homeaway/react-linkpile';
import {replaceSerpUrls} from './helpers';

import './styles.less';

const mapStateToProps = (state, props) => ({
    ...state.seoLinkpile,
    isMobile: state.config.isMobile,
    site: state.config.site.name,
    basePath: state.config.site.basePath,
    domain: state.config.site.domain,
    seoPath: state.destination?.details?.seoPath,
    isRefined: state.config.isRefined,
    forceExpanded: props.forceExpanded,
    useSlpCanonical: state.options.useSlpCanonical,
});

export const SeoLinkpileComponent = (props) => {
    const {
        categories,
        useSlpCanonical,
        site,
        basePath,
        domain,
        seoPath,
        isRefined,
    } = props;
    if (seoPath && categories && useSlpCanonical) {
        categories.forEach((category) => {
            return replaceSerpUrls({
                category,
                site,
                basePath,
                domain,
                seoPath,
                isRefined,
            });
        });
    }
    return <CollapsibleLinkpile {...props} />;
};

export const SeoLinkpile = connect(mapStateToProps)(SeoLinkpileComponent);
SeoLinkpile.displayName = 'SeoLinkpile';

export default SeoLinkpile;
